<template>
  <v-form fast-fail class="edit-user" v-click-outside="cancelAction">
    <h2 class="title mb-2">{{ $t("ticketBuyerTypes.createModal.title") }}</h2>
    <v-text-field
      v-model="userData.name"
      :label="$t('ticketBuyerTypes.createModal.input')"
      @keydown.enter="createWebhsopUser"
    ></v-text-field>

    <div class="btn-row mt-6">
      <v-btn @click="cancelAction">
        {{ $t("ticketBuyerTypes.createModal.cancel") }}
      </v-btn>
      <v-btn
        :disabled="!visibleButton"
        color="primary"
        @click="createWebhsopUser"
      >
        {{ $t("ticketBuyerTypes.createModal.save") }}
      </v-btn>
    </div>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "CreateWebshopUserTypeModal",
  props: {},
  data() {
    return {
      userData: {
        name: "",
      },
    };
  },
  created() {},
  methods: {
    ...mapActions({}),
    cancelAction() {
      if (document.activeElement.tagName != "INPUT") {
        this.emitter.emit("closeModal");
      }
    },
    createWebhsopUser() {
      const createPayload = {
        title: this.userData.name.trimStart(),
      };
      this.$emit("createNewWebshopUserType", createPayload);
      this.emitter.emit("closeModal");
    },
  },
  computed: {
    visibleButton() {
      return this.userData.name.trim().length > 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-user {
  min-width: 400px;
  padding: 24px;
  @media (max-width: 520px) {
    min-width: 300px;
    padding: 12px;
  }
  .btn-row {
    display: flex;
    justify-content: space-between;
    @media (max-width: 520px) {
      flex-direction: column;
      gap: 12px;
    }
  }
}
</style>
